import { ceV2Axios } from './axios';

import { BillingInformation, DataResponse, GeneratedFields, PageableResponse } from '../models';
import { composeQuery, Query } from '../models/query';

export const upsertBillingInformation = async (input: Required<Pick<BillingInformation, 'accountId'>> & Partial<Omit<BillingInformation, 'accountId' | GeneratedFields>> & Partial<Pick<BillingInformation, 'id'>>) => (await ceV2Axios.put<DataResponse<BillingInformation>>('/billing-information', input)).data.data;

export const getBillingInformation = async (...criteria: Query<BillingInformation>[]) => (await ceV2Axios.get<PageableResponse<BillingInformation>>('/billing-information', {
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  },
  params: composeQuery<BillingInformation>(...criteria),
  data: {},
})).data.data;
